// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { StyledButton } from "@insite/mobius/Clickable";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productPriceStyles } from "@vanmeter/Overrides/Components/ProductPrice";
import { fontConfig } from "@vanmeter/XDL/constants";
import { css } from "styled-components";

const sharedUomTextStyles = {
    ...fontConfig.regularSingleLine,
    weight: fontConfig.weight.regular,
    fontFamily: fontConfig.fontFamily,
};

productPriceStyles.quoteMessage = {
    text: {
        variant: "h3",
        as: "p",
        size: 28,
        lineHeight: "32px",
        css: css`
            display: inline;
            margin-bottom: 0;
        `,
    } as TypographyProps,
};

productPriceStyles.price = {
    signInText: {
        ...fontConfig.smallSingleLine,
        css: css`
            ${StyledButton} > ${TypographyStyle} {
                font-size: ${fontConfig.smallSingleLine.size}px;
                line-height: ${fontConfig.smallSingleLine.lineHeight};
            }
        `,
    },
    priceText: {
        variant: "h3",
        as: "p",
        size: 28,
        lineHeight: "32px",
        css: css`
            margin-bottom: 0;
        `,
    } as TypographyProps,
    unitOfMeasureText: { ...sharedUomTextStyles },
    lablePriceWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 4px;
        `,
    },
    saleLabelStyle: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.bold,
        color: "common.ui6",
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
    errorText: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.bold,
    },
};

productPriceStyles.priceContainer = {
    css: css`
        display: flex;
        align-items: baseline;
        ${wrapInContainerStyles}
    `,
};

productPriceStyles.pricePerPricingUomStyle = {
    ...sharedUomTextStyles,
};

productPriceStyles.priceWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        gap: 8px;
    `,
};

// PDP Variant Style
productPriceStyles.pricePerPricingUomPDP = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        b {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

productPriceStyles.priceLabelText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
};

productPriceStyles.pricePerPricingUomWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

productPriceStyles.savingsMessageText = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        b {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};
